import { applyMiddleware } from 'redux';

import allowUIEvents from './middleware/allowUIEvents';

export default applyMiddleware(allowUIEvents);
